export default __webpack_public_path__ + "static/media/search.f5aa3bbd.svg";